import gql from 'graphql-tag';

export default gql`
  mutation activateUserMutation($codeForActivation: String!) {
    activateUserMutation(codeForActivation: $codeForActivation) {
      title
      message
    }
  }
`;
